import { configureStore, combineReducers } from "@reduxjs/toolkit";
import AuraCameraCommon from "./common";
import SurveyDetails from "./inspection-overview/site-operations/survey-details.store";
import UserPreferenceSlice from "./user/user.store";
import RouteDetails from "./inspection-overview/site-operations/route-details.store";
import InspectionOverviewSlice from "./inspection-overview/inspection-overview.store";
import VoluntarySurveySlice from "./voluntary-survey/voluntary-survey.store";
import VoluntarySurveySiteDetails from "./voluntary-survey/site-operations/survey-details.store";

const rootReducer = combineReducers({
  AuraCameraCommon: AuraCameraCommon,
  SurveyDetails: SurveyDetails.reducer,
  UserPreferenceState: UserPreferenceSlice.reducer,
  RouteDetails: RouteDetails.reducer,
  InspectionOverview:InspectionOverviewSlice.reducer,
  VoluntarySurvey:VoluntarySurveySlice.reducer,
  VoluntarySurveySiteDetails:VoluntarySurveySiteDetails.reducer
});

const store = configureStore({
  reducer: rootReducer,
});

export type AppDispatch = typeof store.dispatch;
export type AppState = ReturnType<typeof rootReducer>;

export default store;
